export default {"src":"/_next/static/media/shower_color.e13c186c.svg","height":32,"width":32};